export const PRIVACY_CLARIFICATION_TERM_SHOW_MODAL = "PRIVACY_CLARIFICATION_TERM_SHOW_MODAL";
export const PRIVACY_CLARIFICATION_TERM_HIDE_MODAL = "PRIVACY_CLARIFICATION_TERM_HIDE_MODAL";

export const PRIVACY_PROTECTION_OF_PERSONAL_DATA_SHOW_MODAL = "PRIVACY_PROTECTION_OF_PERSONAL_DATA_SHOW_MODAL";
export const PRIVACY_PROTECTION_OF_PERSONAL_DATA_HIDE_MODAL = "PRIVACY_PROTECTION_OF_PERSONAL_DATA_HIDE_MODAL";
